import { OrganizationKeyName } from "../../../model/Organization";

export const GET_HOMEPAGE_LIST_FAIL = "SHOP:GET_HOMEPAGE_LIST_FAIL";

export const getHomepageListFailAction = (
  organization: OrganizationKeyName
) => ({
  type: GET_HOMEPAGE_LIST_FAIL as typeof GET_HOMEPAGE_LIST_FAIL,
  organization,
});

export type GetHomepageListFailAction = ReturnType<
  typeof getHomepageListFailAction
>;
